import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { submit } from "redux-form";
import {
  DisabledInput,
  required,
  Button,
  SaveButton,
  SimpleForm,
  SelectInput,
  NumberInput
} from "react-admin";
import IconContentAdd from "@material-ui/icons/Add";
import IconContentEdit from "@material-ui/icons/Edit";
import IconCancel from "@material-ui/icons/Cancel";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

class AddLineItemButton extends Component {
  state = {
    error: false,
    showDialog: false,
    formId: +new Date(),
    record: {
      quantity: 0
    }
  };

  handleClick = () => {
    this.setState({
      showDialog: true,
      formId: +new Date(),
      record: {
        quantity: 0
      }
    });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false });
  };

  handleSaveClick = () => {
    const { submit } = this.props;
    const { formId } = this.state;

    // Trigger a submit of our custom quick create form
    // This is needed because our modal action buttons are oustide the form
    submit(formId);
  };

  handleSubmit = lineItemForm => {
    const { addProductToOrder, selectedProd } = this.props;
    this.setState({ showDialog: false });
    if (selectedProd) {
      selectedProd.quantity = lineItemForm.quantity;
      addProductToOrder(selectedProd);
    } else {
      addProductToOrder(lineItemForm);
    }
  };

  static getDerivedStateFromProps(props, state) {
    if (props.selectedProd &&  props.selectedProd.code !== state.record.code) {
      return {
        record: {
          productCode: props.selectedProd.code,
          quantity: props.selectedProd.quantity + ''
        },
      };
    }
    // Return null if the state hasn't changed
    return null;
  }

  render() {
    const { formId, showDialog, record } = this.state;
    const { products, selectedProd } = this.props;    

    return (
      <Fragment>
        <Button
          onClick={this.handleClick}
          label={!selectedProd ? "Agregar producto" : "Editar producto"}
        >
          {!selectedProd ? <IconContentAdd /> : <IconContentEdit />}
        </Button>
        <Dialog
          fullWidth
          open={showDialog}
          onClose={this.handleCloseClick}
          aria-label="Crear Item de la Orden"
          disableEnforceFocus
        >
          <DialogTitle>
            {!selectedProd ? "Crear" : "Editar"} Item de la Orden
          </DialogTitle>
          <DialogContent>
            <SimpleForm
              record={record}
              // We override the redux-form name to avoid collision with the react-admin main form
              form={formId}
              // We override the redux-form onSubmit prop to handle the submission ourselves
              onSubmit={this.handleSubmit}
              // We want no toolbar at all as we have our modal actions
              toolbar={null}
            >
              {!selectedProd ? (
                <SelectInput
                  label="Productos"
                  choices={products}
                  source="productId"
                  optionText="code"
                />
              ) : (
                <DisabledInput label="Producto" source="productCode" />
              )}

              <NumberInput
                label="Cantidad"
                source="quantity"
                validate={[required()]}
              />
            </SimpleForm>
          </DialogContent>
          <DialogActions>
            <SaveButton onClick={this.handleSaveClick} />
            <Button label="ra.action.cancel" onClick={this.handleCloseClick}>
              <IconCancel />
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

const mapDispatchToProps = {
  submit
};

export default connect(
  null,
  mapDispatchToProps
)(AddLineItemButton);
